import { create } from "zustand"

export const useOverlayStore = create((set, get) => ({
  activeId: "",

  toggle: (id) => {
    const { activeId } = get()

    if (activeId === id) {
      return set({ activeId: "" })
    }

    set({ activeId: id })
  },

  close: () => set({ activeId: "" })
}))
